import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />
        <MediaSection />
        <CardsSection />
        <FeaturesSection />
        <AboutSection />
        <ContactSection />
        <FAQSection />
        <AppSection />
        <TopicsSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <IndexSection />
        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}